// externals
import { createSelector } from 'reselect';

// libraries
import type { CachedLenderItem, StateTree } from '@makemydeal/dr-dash-types';

const EMPTY_CACHED_LENDERS: Record<string, Record<string, CachedLenderItem>> = {};

export const getIsLenderAddressLoading = (state: StateTree): boolean => {
    return state.lenderAddress?.lenderAddressFetchStatus?.isLoading || false;
};

export const getHasLenderAddressError = (state: StateTree): boolean => {
    return state.lenderAddress?.lenderAddressFetchStatus?.hasError || false;
};

export const getCachedLenders = createSelector(
    (state: StateTree) => state.lenderAddress?.cachedLenders,
    (
        cachedLenders: Record<string, Record<string, CachedLenderItem>> | undefined
    ): Record<string, Record<string, CachedLenderItem>> => {
        return cachedLenders || EMPTY_CACHED_LENDERS;
    }
);

export const getCachedLender = (state: StateTree, offerType: string, lenderId: string): CachedLenderItem | undefined => {
    return getCachedLenders(state)[offerType]?.[lenderId];
};
